import { useState } from 'react';
export const useNearbyProperties = ({ clickCallback, closeMenu, destinationFieldTranslation, formHooks, }) => {
    const [geolocationPermissionRequested, setGeolocationPermissionRequested] = useState(false);
    const [geolocationPermissionGranted, setGeolocationPermissionGranted] = useState(false);
    const handleNearbyClick = async () => {
        try {
            const result = await clickCallback();
            setGeolocationPermissionGranted(true);
            formHooks.setValue('radiusCentre', `${result.latitude},${result.longitude}`);
            formHooks.setValue('destination', destinationFieldTranslation);
            closeMenu();
        }
        catch (error) {
            setGeolocationPermissionRequested(true);
            setGeolocationPermissionGranted(false);
        }
    };
    return {
        geolocationPermissionRequested,
        geolocationPermissionGranted,
        handleNearbyClick,
    };
};
//# sourceMappingURL=destination-selector.utils.js.map